import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=79b68a4d&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=79b68a4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b68a4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b68a4d')) {
      api.createRecord('79b68a4d', component.options)
    } else {
      api.reload('79b68a4d', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=79b68a4d&scoped=true&", function () {
      api.rerender('79b68a4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2A7KW0VmcxbPA/JS/teamMember.vue"
export default component.exports